module.exports = __webpack_public_path__ + "img/01.ade6e6b7.png";